import { base64Encode, base64Decode } from "../helpers";
import { Provider } from "./base";
export class OAuth2BaseProvider extends Provider {
    async signin(event, auth) {
        const { method } = event.request;
        const { url } = event;
        const state = [
            `redirect=${url.searchParams.get("redirect") ?? this.getUri(auth, "/", url.host)}`,
        ].join(",");
        const base64State = base64Encode(state);
        const nonce = Math.round(Math.random() * 1000).toString();
        const authUrl = await this.getAuthorizationUrl(event, auth, base64State, nonce);
        if (method === "POST") {
            return {
                body: {
                    redirect: authUrl,
                },
            };
        }
        return {
            status: 302,
            headers: {
                Location: authUrl,
            },
        };
    }
    getStateValue(query, name) {
        if (query.get("state")) {
            const state = base64Decode(query.get("state"));
            return state
                .split(",")
                .find((state) => state.startsWith(`${name}=`))
                ?.replace(`${name}=`, "");
        }
    }
    async callback(event, auth) {
        const { request, url } = event;
        const code = url.searchParams.get("code");
        const redirect = this.getStateValue(url.searchParams, "redirect");
        const tokens = await this.getTokens(code, this.getCallbackUri(auth, url.host));
        let user = await this.getUserProfile(tokens);
        if (this.config.profile) {
            user = await this.config.profile(user, tokens);
        }
        return [user, redirect ?? this.getUri(auth, "/", url.host)];
    }
}
